export default __webpack_public_path__ + "static/media/riskometer-m-gsec-fof.e3269d52.png";